import { Autocomplete, TextField, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { Box } from '@mui/system'

import { useImpactTypes } from 'src/hooks'
import { ETranslationNs, IImpactTypeBaseWithId } from 'src/types'
import { HelperWrapper } from 'src/components'

import useStyles from 'src/components/text-input/styles'
import { useStyles as useStyles2 } from './styles'

interface IProps {
  isDisabled?: boolean
}

const ImpactTypeInput = ({ isDisabled }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { data: items, isLoading } = useImpactTypes()
  const { values, handleChange } = useFormikContext<{ types: IImpactTypeBaseWithId[] }>()
  const theme = useTheme()
  const classes = useStyles({})
  const classes2 = useStyles2()

  const handleTypeChange = (event: any, value: null | IImpactTypeBaseWithId[]) => {
    handleChange({
      target: {
        name: 'types',
        value,
      },
    })
  }

  return (
    <Autocomplete
      disabled={isDisabled}
      multiple
      disablePortal
      autoHighlight
      disableClearable
      defaultValue={values.types}
      options={items?.data || []}
      ListboxProps={{ className: classes2.inputList }}
      value={values.types}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      getOptionLabel={(option) => option?.name}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
          {option.name}
        </Box>
      )}
      fullWidth
      onChange={handleTypeChange}
      loading={isLoading}
      loadingText={t('loading-text-notification.v')}
      renderInput={(props) => (
        <TextField
          {...props}
          disabled={isDisabled}
          autoComplete="off"
          variant="standard"
          className={classes.container}
          style={{ height: '100%' }}
          InputProps={{
            ...props.InputProps,
            disableUnderline: true,
          }}
          inputProps={{
            ...props.inputProps,
            className: classes.input,
          }}
          InputLabelProps={{
            className: classes.label,
            style: {
              color: theme.palette.custom.grey2,
            },
          }}
          size="small"
          label={<HelperWrapper t="impact-type-input-label" isColorInherited usePortal />}
          id="types"
          name="types"
          focused
          placeholder={`${t('text-input-placeholder-prepend.v', { ns: ETranslationNs.Form })} ${t(
            'impact-type-input-placeholder.v',
          )}`}
          type="text"
        />
      )}
    />
  )
}

export { ImpactTypeInput }
